import React, { useState, useEffect } from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CelebrationIcon from "@mui/icons-material/Celebration";
import ContactsIcon from "@mui/icons-material/Contacts";
import PeopleIcon from "@mui/icons-material/People";
import WorkIcon from "@mui/icons-material/Work";
import BadgeIcon from "@mui/icons-material/Badge";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import PaymentIcon from "@mui/icons-material/Payment";
import LanIcon from "@mui/icons-material/Lan";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import WebAssetIcon from "@mui/icons-material/WebAsset";
import DraftsIcon from "@mui/icons-material/Drafts";
import AssessmentIcon from "@mui/icons-material/Assessment";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import Groups2Icon from "@mui/icons-material/Groups2";
import BugReportIcon from "@mui/icons-material/BugReport";
import MessageIcon from "@mui/icons-material/Message";
import EventNoteIcon from "@mui/icons-material/EventNote";
import SchoolIcon from "@mui/icons-material/School";
import HelpIcon from "@mui/icons-material/Help";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import SettingsIcon from "@mui/icons-material/Settings";
import AttributionIcon from "@mui/icons-material/Attribution";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import DirectionsBusFilledIcon from "@mui/icons-material/DirectionsBusFilled";
import TollIcon from "@mui/icons-material/Toll";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import LogoExpanded from "../../assets/mainlogo.png";
import SidebarIcons from "./SidebarIcons";
import { useSelector } from "react-redux";
import { ticketApis } from "../../Data/axios";

function MainSidebar({ onClose }) {
  const userPermissions = useSelector((state) => state?.user?.permissions);
  const isTestUser = useSelector((state) => state?.user?.isTestUser);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("");
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [openTicketsCount, setOpenTicketsCount] = useState(0);
  // const [open, setOpen] = useState(false);

  // Fetch open tickets count on mount
  useEffect(() => {
    const fetchOpenTicketsCount = async () => {
      try {
        // Use the same API as the tickets page
        const response = await ticketApis.getTicketonDashboard();

        console.log("Sidebar - Ticket Dashboard Response:", response);

        if (response.success && response.data && Array.isArray(response.data.tickets)) {
          // Count tickets where status is 1 (Open)
          const openTickets = response.data.tickets.filter(
            ticket => ticket.status === 1 || ticket.status === "1"
          );
          console.log("Sidebar - Open Tickets Count:", openTickets.length);
          setOpenTicketsCount(openTickets.length);
        }
      } catch (error) {
        console.error("Error fetching open tickets count:", error);
        setOpenTicketsCount(0);
      }
    };

    fetchOpenTicketsCount();

    // Refresh count every 60 seconds
    const interval = setInterval(fetchOpenTicketsCount, 60000);

    return () => clearInterval(interval);
  }, []);

  const handleSubMenuClick = (submenu) => {
    submenu === activeSubMenu
      ? setActiveSubMenu(null)
      : setActiveSubMenu(submenu);
  };

  const handleMenuItemClick = (itemName) => {
    setSelected(itemName);
    onClose && onClose();
  };

  // Format badge count (show 9+ if more than 9)
  const formatBadgeCount = (count) => {
    return count > 9 ? "9+" : count.toString();
  };

  // Limited menu items for test users
  const TestUserComponentLists = [
    <MenuItem
      key="attendance"
      style={{
        display: "flex",
        alignItems: "center",
        color: selected === "attendance" ? "white" : "black",
        backgroundColor: selected === "attendance" ? "#C0B476" : "transparent",
        marginLeft: "10px",
      }}
      component={<Link to="/hr/attendance" />}
      onClick={() => handleMenuItemClick("attendance")}
    >
      <EventNoteIcon style={{ marginRight: "15px", marginBottom: "-5px" }} />
      Attendance
    </MenuItem>,
    <MenuItem
      key="trips"
      style={{
        display: "flex",
        alignItems: "center",
        color: selected === "trips" ? "white" : "black",
        backgroundColor: selected === "trips" ? "#C0B476" : "transparent",
        marginLeft: "10px",
      }}
      component={<Link to="/trips" />}
      onClick={() => handleMenuItemClick("trips")}
    >
      <DirectionsBusFilledIcon
        style={{ marginRight: "15px", marginBottom: "-5px" }}
      />
      Trips
    </MenuItem>,
  ];

  const ComponentLists = [
    <SubMenu
      label="DashBoard"
      icon={<DashboardIcon style={{ color: "black" }} />}
      style={{ display: "flex", alignItems: "center", color: "black" }}
      open={activeSubMenu === "dashboard"}
      onClick={() => handleSubMenuClick("dashboard")}
    >
      {userPermissions?.admin_settings !== 0 && (
        <MenuItem
          component={<Link to="/rptpl" />}
          style={{
            color: selected === "Private DashBoard" ? "white" : "black",
            backgroundColor:
              selected === "Private DashBoard" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("Private DashBoard")}
        >
          Private DashBoard
        </MenuItem>
      )}
      {userPermissions?.admin_dashboard !== 0 && (
        <MenuItem
          component={<Link to="/admin-dashboard" />}
          style={{
            color: selected === "Admin DashBoard" ? "white" : "black",
            backgroundColor:
              selected === "Admin DashBoard" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("Admin DashBoard")}
        >
          Admin DashBoard
        </MenuItem>
      )}
    </SubMenu>,
    <SubMenu
      label="Leads"
      icon={<ContactsIcon style={{ color: "black" }} />}
      //iconColor="black"
      style={{ display: "flex", alignItems: "center", color: "black" }}
      open={activeSubMenu === "leads"}
      onClick={() => handleSubMenuClick("leads")}
    >
      {userPermissions?.sales !== 0 && (
        <MenuItem
          component={<Link to="/leads/sales" />}
          style={{
            color: selected === "Sales" ? "white" : "black",
            backgroundColor: selected === "Sales" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("Sales")}
        >
          Sales
        </MenuItem>
      )}

      {userPermissions?.leads !== 0 && (
        <MenuItem
          component={<Link to="/leads" />}
          style={{
            color: selected === "Leads" ? "white" : "black",
            backgroundColor: selected === "Leads" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("Leads")}
        >
          Leads
        </MenuItem>
      )}
    </SubMenu>,
    userPermissions?.onfield !== 0 && (
      <MenuItem
        style={{
          display: "flex",
          alignItems: "center",
          color: selected === "sales_team" ? "white" : "black",
          backgroundColor:
            selected === "sales_team" ? "#C0B476" : "transparent",
          marginLeft: "10px",
        }}
        component={<Link to="/field_team" />}
        onClick={() => handleMenuItemClick("sales_team")}
      >
        <AttributionIcon
          style={{ marginRight: "15px", marginBottom: "-5px" }}
        />
        OnField Team
      </MenuItem>
    ),
    userPermissions?.users !== 0 && (
      <SubMenu
        label="Users"
        icon={<PeopleIcon style={{ color: "black" }} />}
        //iconColor="black"
        style={{ display: "flex", alignItems: "center", color: "black" }}
        open={activeSubMenu === "users"}
        onClick={() => handleSubMenuClick("users")}
      >
        {userPermissions?.users_driver !== 0 && (
          <MenuItem
            component={<Link to="/Users/Drivers" />}
            style={{
              color: selected === "drivers" ? "white" : "black",
              backgroundColor:
                selected === "drivers" ? "#C0B476" : "transparent",
            }}
            onClick={() => handleMenuItemClick("drivers")}
          >
            Drivers
          </MenuItem>
        )}
        {userPermissions?.users_owner !== 0 && (
          <MenuItem
            component={<Link to="/Users/Fleet_Owners" />}
            style={{
              color: selected === "Fleet-Owners" ? "white" : "black",
              backgroundColor:
                selected === "Fleet-Owners" ? "#C0B476" : "transparent",
            }}
            onClick={() => handleMenuItemClick("Fleet-Owners")}
          >
            Fleet Owners
          </MenuItem>
        )}

        {userPermissions?.users_dhaba !== 0 && (
          <MenuItem
            component={<Link to="/Users/Dhaba" />}
            style={{
              color: selected === "Dhaba" ? "white" : "black",
              backgroundColor: selected === "Dhaba" ? "#C0B476" : "transparent",
            }}
            onClick={() => handleMenuItemClick("Dhaba")}
          >
            Dhaba
          </MenuItem>
        )}
        {userPermissions?.users_mech !== 0 && (
          <MenuItem
            component={<Link to="/Users/mech_user" />}
            style={{
              color: selected === "Mechanic" ? "white" : "black",
              backgroundColor:
                selected === "Mechanic" ? "#C0B476" : "transparent",
            }}
            onClick={() => handleMenuItemClick("Mechanic")}
          >
            Mechanic
          </MenuItem>
        )}
        {userPermissions?.users_crane_owner !== 0 && (
          <MenuItem
            component={<Link to="/Users/Crane_Owners" />}
            style={{
              color: selected === "Crane-Owners" ? "white" : "black",
              backgroundColor:
                selected === "Crane-Owners" ? "#C0B476" : "transparent",
            }}
            onClick={() => handleMenuItemClick("Crane-Owners")}
          >
            Crane Owners
          </MenuItem>
        )}
        {userPermissions?.users_crane_operator !== 0 && (
          <MenuItem
            component={<Link to="/Users/Crane_Ope" />}
            style={{
              color: selected === "Crane" ? "white" : "black",
              backgroundColor: selected === "Crane" ? "#C0B476" : "transparent",
            }}
            onClick={() => handleMenuItemClick("Crane")}
          >
            Crane Operator
          </MenuItem>
        )}
      </SubMenu>
    ),

    <MenuItem
      style={{
        display: "flex",
        alignItems: "center",
        color: selected === "membership" ? "white" : "black",
        backgroundColor: selected === "membership" ? "#C0B476" : "transparent",
        marginLeft: "10px",
      }}
      component={<Link to="/membership" />}
      onClick={() => handleMenuItemClick("membership")}
    >
      <LoyaltyIcon style={{ marginRight: "15px", marginBottom: "-5px" }} />
      Membership
    </MenuItem>,
    userPermissions?.assets !== 0 && (
      <MenuItem
        style={{
          display: "flex",
          alignItems: "center",
          color: selected === "clients" ? "white" : "black",
          backgroundColor: selected === "clients" ? "#C0B476" : "transparent",
          marginLeft: "10px",
        }}
        component={<Link to="/clients" />}
        onClick={() => handleMenuItemClick("clients")}
      >
        <PeopleIcon style={{ marginRight: "15px", marginBottom: "-5px" }} />
        Clients
      </MenuItem>
    ),
    userPermissions?.trips !== 0 && (
      <MenuItem
        style={{
          display: "flex",
          alignItems: "center",
          color: selected === "trips" ? "white" : "black",
          backgroundColor:
            selected === "trips" ? "#C0B476" : "transparent",
          marginLeft: "10px",
        }}
        component={<Link to="/trips" />}
        onClick={() => handleMenuItemClick("trips")}
      >
        <DirectionsBusFilledIcon
          style={{ marginRight: "15px", marginBottom: "-5px" }}
        />
        Trips
      </MenuItem>
    ),
    <MenuItem
      style={{
        display: "flex",
        alignItems: "center",
        color: selected === "FASTag" ? "white" : "black",
        backgroundColor:
          selected === "FASTag" ? "#C0B476" : "transparent",
        marginLeft: "10px",
      }}
      component={<Link to="/fasttag" />}
      onClick={() => handleMenuItemClick("FASTag")}
    >
      <TollIcon style={{ marginRight: "15px", marginBottom: "-5px" }} />
      FASTag
    </MenuItem>,
    <SubMenu
      label="Drivers"
      icon={<AssignmentIndIcon style={{ color: "black" }} />}
      style={{ display: "flex", alignItems: "center", color: "black" }}
      open={activeSubMenu === "drivers"}
      onClick={() => handleSubMenuClick("drivers")}
    >
      <MenuItem
        component={<Link to="/driver/leave_requests" />}
        style={{
          color: selected === "Leave Requests" ? "white" : "black",
          backgroundColor:
            selected === "Leave Requests" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("Leave Requests")}
      >
        Leave Requests
      </MenuItem>

      <MenuItem
        component={<Link to="/driver/salary" />}
        style={{
          color: selected === "Driver Salary" ? "white" : "black",
          backgroundColor:
            selected === "Driver Salary" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("Driver Salary")}
      >
        Driver Salary
      </MenuItem>
    </SubMenu>,

    // userPermissions?.vehicals_data !== 0 && (
    //   <MenuItem
    //     style={{
    //       display: "flex",
    //       alignItems: "center",
    //       color: selected === "Vehicals_Data" ? "white" : "black",
    //       backgroundColor:
    //         selected === "Vehicals_Data" ? "#C0B476" : "transparent",
    //       marginLeft: "10px",
    //     }}
    //     component={<Link to="/Vehicals_Data" />}
    //     onClick={() => handleMenuItemClick("Vehicals_Data")}
    //   >
    //     <DirectionsBusFilledIcon
    //       style={{ marginRight: "15px", marginBottom: "-5px" }}
    //     />
    //     Vehicals Data
    //   </MenuItem>
    // ),
        <SubMenu
      label="Vehicle Data"
      icon={<LocalShippingIcon style={{ color: "black" }} />}
      style={{ display: "flex", alignItems: "center", color: "black" }}
      open={activeSubMenu === "vehicle_data"}
      onClick={() => handleSubMenuClick("vehicle_data")}
    >
      <MenuItem
        component={<Link to="/Vehicals_Data" />}
        style={{
          color: selected === "Vehicle Data" ? "white" : "black",
          backgroundColor:
            selected === "Vehicle Data" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("Vehicle Data")}
      >
        Vehicle Data
      </MenuItem>

      <MenuItem
        component={<Link to="/fleet-vehicles" />}
        style={{
          color: selected === "Fleet Vehicle" ? "white" : "black",
          backgroundColor:
            selected === "Fleet Vehicle" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("Fleet Vehicle")}
      >
        Fleet Vehicle
      </MenuItem>
    </SubMenu>,
    userPermissions?.assets !== 0 && (
      <MenuItem
        style={{
          display: "flex",
          alignItems: "center",
          color: selected === "Convoy" ? "white" : "black",
          backgroundColor: selected === "Convoy" ? "#C0B476" : "transparent",
          marginLeft: "10px",
        }}
        component={<Link to="/Convoy" />}
        onClick={() => handleMenuItemClick("Convoy")}
      >
        <AccountTreeIcon
          style={{ marginRight: "15px", marginBottom: "-5px" }}
        />
        Convoy
      </MenuItem>
    ),
    userPermissions?.crane_booking !== 0 && (
      <MenuItem
        style={{
          display: "flex",
          alignItems: "center",
          color: selected === "crane_booking" ? "white" : "black",
          backgroundColor:
            selected === "crane_booking" ? "#C0B476" : "transparent",
          marginLeft: "10px",
        }}
        component={<Link to="/crane_booking" />}
        onClick={() => handleMenuItemClick("crane_booking")}
      >
        <PrecisionManufacturingIcon
          style={{ marginRight: "15px", marginBottom: "-5px" }}
        />
        Crane Bookings
      </MenuItem>
    ),

    <SubMenu
      label="Jobs"
      icon={<LocalShippingIcon style={{ color: "black" }} />}
      iconColor="black"
      style={{ display: "flex", alignItems: "center", color: "black" }}
      open={activeSubMenu === "jobs"}
      onClick={() => handleSubMenuClick("jobs")}
    >
      {userPermissions?.jobs !== 0 && (
        <MenuItem
          component={<Link to="/jobs/created" />}
          style={{
            color: selected === "Jobs Created" ? "white" : "black",
            backgroundColor:
              selected === "Jobs Created" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("Jobs Created")}
        >
          Vacancies Created
        </MenuItem>
      )}
      {userPermissions?.jobs_application !== 0 && (
        <MenuItem
          component={<Link to="/jobs/applications" />}
          style={{
            color: selected === "Applications" ? "white" : "black",
            backgroundColor:
              selected === "Applications" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("Applications")}
        >
          Job Applications
        </MenuItem>
      )}
    </SubMenu>,

    <SubMenu
      label="HR"
      icon={<BadgeIcon style={{ color: "black" }} />}
      //iconColor="black"
      style={{ display: "flex", alignItems: "center", color: "black" }}
      open={activeSubMenu === "hr"}
      onClick={() => handleSubMenuClick("hr")}
    >
      {userPermissions?.employees !== 0 && (
        <MenuItem
          component={<Link to="/hr/employees" />}
          style={{
            color: selected === "employees" ? "white" : "black",
            backgroundColor:
              selected === "employees" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("employees")}
        >
          Employees
        </MenuItem>
      )}
      {userPermissions?.employees_leaves !== 0 && (
        <MenuItem
          component={<Link to="/hr/leaves" />}
          style={{
            color: selected === "leaves" ? "white" : "black",
            backgroundColor: selected === "leaves" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("leaves")}
        >
          Leaves
        </MenuItem>
      )}
      {userPermissions?.hr_shift !== 0 && (
        <MenuItem
          component={<Link to="/hr/shift" />}
          style={{
            color: selected === "shift" ? "white" : "black",
            backgroundColor: selected === "shift" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("shift")}
        >
          Shift Roster
        </MenuItem>
      )}
      {userPermissions?.hr_attendance !== 0 && (
        <MenuItem
          component={<Link to="/hr/attendance" />}
          style={{
            color: selected === "attendance" ? "white" : "black",
            backgroundColor:
              selected === "attendance" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("attendance")}
        >
          Attendance
        </MenuItem>
      )}
      {userPermissions?.hr_holidays !== 0 && (
        <MenuItem
          component={<Link to="/hr/holiday" />}
          style={{
            color: selected === "holiday" ? "white" : "black",
            backgroundColor: selected === "holiday" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("holiday")}
        >
          Holiday
        </MenuItem>
      )}
      {userPermissions?.hr_designation !== 0 && (
        <MenuItem
          component={<Link to="/hr/designation" />}
          style={{
            color: selected === "designation" ? "white" : "black",
            backgroundColor:
              selected === "designation" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("designation")}
        >
          Designation
        </MenuItem>
      )}
      {userPermissions?.hr_department !== 0 && (
        <MenuItem
          component={<Link to="/hr/department" />}
          style={{
            color: selected === "department" ? "white" : "black",
            backgroundColor:
              selected === "department" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("department")}
        >
          Department
        </MenuItem>
      )}

      {userPermissions?.hr_appreciation !== 0 && (
        <MenuItem
          component={<Link to="/hr/appreciation" />}
          style={{
            color: selected === "appreciation" ? "white" : "black",
            backgroundColor:
              selected === "appreciation" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("appreciation")}
        >
          Appreciation
        </MenuItem>
      )}
    </SubMenu>,
    userPermissions?.payroll !== 0 && (
      <SubMenu
        label="Payroll"
        icon={<PaymentIcon style={{ color: "black" }} />}
        //iconColor="black"
        style={{ display: "flex", alignItems: "center", color: "black" }}
        open={activeSubMenu === "payroll"}
        onClick={() => handleSubMenuClick("payroll")}
      >
        {userPermissions?.payroll_staff_salary !== 0 && (
          <MenuItem
            component={<Link to="/payroll/staff" />}
            style={{
              color: selected === "staff" ? "white" : "black",
              backgroundColor: selected === "staff" ? "#C0B476" : "transparent",
            }}
            onClick={() => handleMenuItemClick("staff")}
          >
            Staff Salary
          </MenuItem>
        )}

        {userPermissions?.report !== 0 && (
          <MenuItem
            component={<Link to="/payroll/report" />}
            style={{
              color: selected === "payroll" ? "white" : "black",
              backgroundColor:
                selected === "payroll" ? "#C0B476" : "transparent",
            }}
            onClick={() => handleMenuItemClick("payroll")}
          >
            Report
          </MenuItem>
        )}
      </SubMenu>
    ),

    userPermissions?.work !== 0 && (
      <SubMenu
        label="Work"
        icon={<LanIcon style={{ color: "black" }} />}
        //iconColor="black"
        style={{ display: "flex", alignItems: "center", color: "black" }}
        open={activeSubMenu === "work"}
        onClick={() => handleSubMenuClick("work")}
      >
        <MenuItem
          component={<Link to="/work/contracts" />}
          style={{
            color: selected === "contracts" ? "white" : "black",
            backgroundColor:
              selected === "contracts" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("contracts")}
        >
          Contracts
        </MenuItem>
        <MenuItem
          component={<Link to="/work/projects" />}
          style={{
            color: selected === "projects" ? "white" : "black",
            backgroundColor:
              selected === "projects" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("projects")}
        >
          Projects
        </MenuItem>

        <MenuItem
          component={<Link to="/work/tasks" />}
          style={{
            color: selected === "tasks" ? "white" : "black",
            backgroundColor: selected === "tasks" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("tasks")}
        >
          Tasks
        </MenuItem>

        <MenuItem
          component={<Link to="/work/time_Sheet" />}
          style={{
            color: selected === "time_Sheet" ? "white" : "black",
            backgroundColor:
              selected === "time_Sheet" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("time_Sheet")}
        >
          Time Sheet
        </MenuItem>
      </SubMenu>
    ),
    userPermissions?.events !== 0 && (
      <SubMenu
        label="Finance"
        icon={<CurrencyRupeeIcon style={{ color: "black" }} />}
        //iconColor="black"
        style={{ display: "flex", alignItems: "center", color: "black" }}
        open={activeSubMenu === "finance"}
        onClick={() => handleSubMenuClick("finance")}
      >
        <MenuItem
          component={<Link to="/finance/proposal" />}
          style={{
            color: selected === "proposal" ? "white" : "black",
            backgroundColor:
              selected === "proposal" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("proposal")}
        >
          Proposal
        </MenuItem>
        <MenuItem
          component={<Link to="/finance/estimate" />}
          style={{
            color: selected === "estimate" ? "white" : "black",
            backgroundColor:
              selected === "estimate" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("estimate")}
        >
          Estimates
        </MenuItem>

        <MenuItem
          component={<Link to="/finance/invoice" />}
          style={{
            color: selected === "invoice" ? "white" : "black",
            backgroundColor: selected === "invoice" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("invoice")}
        >
          Invoice
        </MenuItem>
        <MenuItem
          component={<Link to="/finance/payments" />}
          style={{
            color: selected === "payments" ? "white" : "black",
            backgroundColor:
              selected === "payments" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("payments")}
        >
          Payments
        </MenuItem>
        <MenuItem
          component={<Link to="/finance/credit" />}
          style={{
            color: selected === "credit" ? "white" : "black",
            backgroundColor: selected === "credit" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("credit")}
        >
          Credit Note
        </MenuItem>
        <MenuItem
          component={<Link to="/finance/expenses" />}
          style={{
            color: selected === "expenses" ? "white" : "black",
            backgroundColor:
              selected === "expenses" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("expenses")}
        >
          Expenses
        </MenuItem>
        <MenuItem
          component={<Link to="/finance/bank" />}
          style={{
            color: selected === "bank" ? "white" : "black",
            backgroundColor: selected === "bank" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("bank")}
        >
          Bank Details
        </MenuItem>
        <MenuItem
          component={<Link to="/finance/settlements" />}
          style={{
            color: selected === "settlements" ? "white" : "black",
            backgroundColor:
              selected === "settlements" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("settlements")}
        >
          Settlements
        </MenuItem>
        <MenuItem
          component={<Link to="/finance/Wallet" />}
          style={{
            color: selected === "Wallet" ? "white" : "black",
            backgroundColor: selected === "Wallet" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("Wallet")}
        >
          Wallet
        </MenuItem>
      </SubMenu>
    ),
    userPermissions?.assets !== 0 && (
      <SubMenu
        label="Assets"
        icon={<WebAssetIcon style={{ color: "black" }} />}
        //iconColor="black"
        style={{ display: "flex", alignItems: "center", color: "black" }}
        open={activeSubMenu === "assets"}
        onClick={() => handleSubMenuClick("assets")}
      >
        <MenuItem
          component={<Link to="/assets" />}
          style={{
            color: selected === "assets" ? "white" : "black",
            backgroundColor: selected === "assets" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("assets")}
        >
          Assets
        </MenuItem>
        <MenuItem
          component={<Link to="/assets/products" />}
          style={{
            color: selected === "products" ? "white" : "black",
            backgroundColor:
              selected === "products" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("products")}
        >
          Products
        </MenuItem>

        <MenuItem
          component={<Link to="/assets/orders" />}
          style={{
            color: selected === "orders" ? "white" : "black",
            backgroundColor: selected === "orders" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("orders")}
        >
          Orders
        </MenuItem>
        <MenuItem
          component={<Link to="/assets/vendor" />}
          style={{
            color: selected === "vendor" ? "white" : "black",
            backgroundColor: selected === "vendor" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("vendor")}
        >
          Vendor
        </MenuItem>
        <MenuItem
          component={<Link to="/assets/purchase_order" />}
          style={{
            color: selected === "purchase_order" ? "white" : "black",
            backgroundColor:
              selected === "purchase_order" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("purchase_order")}
        >
          Purchase Order
        </MenuItem>
        <MenuItem
          component={<Link to="/assets/bills" />}
          style={{
            color: selected === "bills" ? "white" : "black",
            backgroundColor: selected === "bills" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("bills")}
        >
          Bills
        </MenuItem>
        <MenuItem
          component={<Link to="/assets/vendor_payments" />}
          style={{
            color: selected === "vendor_payments" ? "white" : "black",
            backgroundColor:
              selected === "vendor_payments" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("vendor_payments")}
        >
          Vendor Payments
        </MenuItem>
        <MenuItem
          component={<Link to="/assets/vendor_credits" />}
          style={{
            color: selected === "vendor_credits" ? "white" : "black",
            backgroundColor:
              selected === "vendor_credits" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("vendor_credits")}
        >
          Vendor Credits
        </MenuItem>
        <MenuItem
          component={<Link to="/assets/Inventory" />}
          style={{
            color: selected === "Inventory" ? "white" : "black",
            backgroundColor:
              selected === "Inventory" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("Inventory")}
        >
          Inventory
        </MenuItem>
        <MenuItem
          component={<Link to="/assets/Report" />}
          style={{
            color: selected === "Report" ? "white" : "black",
            backgroundColor: selected === "Report" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("Report")}
        >
          Reports
        </MenuItem>
      </SubMenu>
    ),
    userPermissions?.letter !== 0 && (
      <SubMenu
        label="Letter"
        icon={<DraftsIcon style={{ color: "black" }} />}
        //iconColor="black"
        style={{ display: "flex", alignItems: "center", color: "black" }}
        open={activeSubMenu === "letter"}
        onClick={() => handleSubMenuClick("letter")}
      >
        <MenuItem
          component={<Link to="/letter/generate" />}
          style={{
            color: selected === "generate" ? "white" : "black",
            backgroundColor:
              selected === "generate" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("generate")}
        >
          Generate
        </MenuItem>
        <MenuItem
          component={<Link to="/letter/templete" />}
          style={{
            color: selected === "templete" ? "white" : "black",
            backgroundColor:
              selected === "templete" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("templete")}
        >
          Templetes
        </MenuItem>
      </SubMenu>
    ),

    <SubMenu
      label="Recruit"
      icon={<WorkIcon style={{ color: "black" }} />}
      //iconColor="black"
      style={{ display: "flex", alignItems: "center", color: "black" }}
      open={activeSubMenu === "recruit"}
      onClick={() => handleSubMenuClick("recruit")}
    >
      <MenuItem
        component={<Link to="/recruit/dashboard" />}
        style={{
          color: selected === "rdashboard" ? "white" : "black",
          backgroundColor:
            selected === "rdashboard" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("rdashboard")}
      >
        DashBoard
      </MenuItem>
      <MenuItem
        component={<Link to="/recruit/skills" />}
        style={{
          color: selected === "skills" ? "white" : "black",
          backgroundColor: selected === "skills" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("skills")}
      >
        Skills
      </MenuItem>
      <MenuItem
        component={<Link to="/recruit/jobs" />}
        style={{
          color: selected === "jobs" ? "white" : "black",
          backgroundColor: selected === "jobs" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("jobs")}
      >
        Jobs
      </MenuItem>

      <MenuItem
        component={<Link to="/recruit/applications" />}
        style={{
          color: selected === "applications" ? "white" : "black",
          backgroundColor:
            selected === "applications" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("applications")}
      >
        Applications
      </MenuItem>
      <MenuItem
        component={<Link to="/recruit/interview" />}
        style={{
          color: selected === "interview" ? "white" : "black",
          backgroundColor: selected === "interview" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("interview")}
      >
        Interview Schedule
      </MenuItem>
      <MenuItem
        component={<Link to="/recruit/site" />}
        style={{
          color: selected === "site" ? "white" : "black",
          backgroundColor: selected === "site" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("site")}
      >
        Career Site
      </MenuItem>
      <MenuItem
        component={<Link to="/recruit/candDb" />}
        style={{
          color: selected === "candidates" ? "white" : "black",
          backgroundColor:
            selected === "candidates" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("candidates")}
      >
        Candidates Database
      </MenuItem>
      <MenuItem
        component={<Link to="/recruit/offer" />}
        style={{
          color: selected === "offer" ? "white" : "black",
          backgroundColor: selected === "offer" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("offer")}
      >
        Offer Letter
      </MenuItem>
      <MenuItem
        component={<Link to="/recruit/reports" />}
        style={{
          color: selected === "oreports" ? "white" : "black",
          backgroundColor: selected === "oreports" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("oreports")}
      >
        Reports
      </MenuItem>
    </SubMenu>,
    userPermissions?.meetings !== 0 && (
      <SubMenu
        label="Meetings"
        icon={<Groups2Icon style={{ color: "black" }} />}
        //iconColor="black"
        style={{ display: "flex", alignItems: "center", color: "black" }}
        open={activeSubMenu === "meetings"}
        onClick={() => handleSubMenuClick("meetings")}
      >
        <MenuItem
          component={<Link to="/meetings/zoom" />}
          style={{
            color: selected === "zoom" ? "white" : "black",
            backgroundColor: selected === "zoom" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("zoom")}
        >
          Zoom
        </MenuItem>
        <MenuItem
          component={<Link to="/meetings/teams" />}
          style={{
            color: selected === "Teams" ? "white" : "black",
            backgroundColor: selected === "Teams" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("Teams")}
        >
          Teams
        </MenuItem>
        <MenuItem
          component={<Link to="/meetings/jitsi" />}
          style={{
            color: selected === "jitsi" ? "white" : "black",
            backgroundColor: selected === "jitsi" ? "#C0B476" : "transparent",
          }}
          onClick={() => handleMenuItemClick("jitsi")}
        >
          Jitsi
        </MenuItem>
      </SubMenu>
    ),

    userPermissions?.tickets !== 0 && (
      <MenuItem
        style={{
          display: "flex",
          alignItems: "center",
          color: selected === "tickets" ? "white" : "black",
          backgroundColor: selected === "tickets" ? "#C0B476" : "transparent",
          marginLeft: "10px",
        }}
        component={<Link to="/tickets" />}
        onClick={() => handleMenuItemClick("tickets")}
      >
        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
          <Box sx={{ display: "flex", alignItems: "center", position: "relative", marginRight: "15px" }}>
            <BugReportIcon
              sx={{
                fontSize: "22px",
                color: "black",
                marginBottom: "-3px",
              }}
            />
            {/* Badge next to "Tickets" label - always shows even with 0 */}
            <Box
              sx={{
                position: "absolute",
                right: "-6px",
                backgroundColor: "#d32f2f",
                color: "#ffffff",
                fontSize: "11px",
                fontWeight: "bold",
                minWidth: "18px",
                height: "18px",
                borderRadius: "9px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0 6px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                border: "2px solid #ffffff",
                zIndex: 10,
              }}
            >
              {formatBadgeCount(openTicketsCount)}
            </Box>
            Tickets
            </Box>
          </Box>
      </MenuItem>
    ),
    userPermissions?.events !== 0 && (
      <MenuItem
        style={{
          display: "flex",
          alignItems: "center",
          color: selected === "Calendar" ? "white" : "black",
          backgroundColor: selected === "Calendar" ? "#C0B476" : "transparent",
          marginLeft: "10px",
        }}
        component={<Link to="/events" />}
        onClick={() => handleMenuItemClick("Calendar")}
      >
        <CelebrationIcon
          style={{ marginRight: "15px", marginBottom: "-5px" }}
        />
        Events
      </MenuItem>
    ),

    <MenuItem
      style={{
        display: "flex",
        alignItems: "center",
        color: selected === "message" ? "white" : "black",
        backgroundColor: selected === "message" ? "#C0B476" : "transparent",
        marginLeft: "10px",
      }}
      component={<Link to="/message" />}
      onClick={() => handleMenuItemClick("message")}
    >
      <MessageIcon style={{ marginRight: "15px", marginBottom: "-5px" }} />
      Message
    </MenuItem>,
    userPermissions?.notice !== 0 && (
      <MenuItem
        style={{
          display: "flex",
          alignItems: "center",
          color: selected === "notice" ? "white" : "black",
          backgroundColor: selected === "notice" ? "#C0B476" : "transparent",
          marginLeft: "10px",
        }}
        component={<Link to="/notice" />}
        onClick={() => handleMenuItemClick("notice")}
      >
        <EventNoteIcon style={{ marginRight: "15px", marginBottom: "-5px" }} />
        Notice Board
      </MenuItem>
    ),
    userPermissions?.knowledge !== 0 && (
      <MenuItem
        style={{
          display: "flex",
          alignItems: "center",
          color: selected === "knowledge" ? "white" : "black",
          backgroundColor: selected === "knowledge" ? "#C0B476" : "transparent",
          marginLeft: "10px",
        }}
        component={<Link to="/knowledge" />}
        onClick={() => handleMenuItemClick("knowledge")}
      >
        <SchoolIcon style={{ marginRight: "15px", marginBottom: "-5px" }} />
        Knowledge Base
      </MenuItem>
    ),

    <SubMenu
      label="Reports"
      icon={<AssessmentIcon style={{ color: "black" }} />}
      //iconColor="black"
      style={{ display: "flex", alignItems: "center", color: "black" }}
      open={activeSubMenu === "reports"}
      onClick={() => handleSubMenuClick("reports")}
    >
      <MenuItem
        component={<Link to="/report/task" />}
        style={{
          color: selected === "rtask" ? "white" : "black",
          backgroundColor: selected === "rtask" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("rtask")}
      >
        Task Report
      </MenuItem>
      <MenuItem
        component={<Link to="/report/time_log" />}
        style={{
          color: selected === "reporttime_log" ? "white" : "black",
          backgroundColor:
            selected === "reporttime_log" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("reporttime_log")}
      >
        Time Log Report
      </MenuItem>

      <MenuItem
        component={<Link to="/report/finance" />}
        style={{
          color: selected === "reportfinance" ? "white" : "black",
          backgroundColor:
            selected === "reportfinance" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("reportfinance")}
      >
        Finance Report
      </MenuItem>
      <MenuItem
        component={<Link to="/report/income" />}
        style={{
          color: selected === "income" ? "white" : "black",
          backgroundColor: selected === "income" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("income")}
      >
        Income Vs Expense
      </MenuItem>
      <MenuItem
        component={<Link to="/report/leave" />}
        style={{
          color: selected === "reportleave" ? "white" : "black",
          backgroundColor:
            selected === "reportleave" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("reportleave")}
      >
        Leave Report
      </MenuItem>
      <MenuItem
        component={<Link to="/report/deal" />}
        style={{
          color: selected === "deal" ? "white" : "black",
          backgroundColor: selected === "deal" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("deal")}
      >
        Deal Report
      </MenuItem>
      <MenuItem
        component={<Link to="/report/sales" />}
        style={{
          color: selected === "sales" ? "white" : "black",
          backgroundColor: selected === "sales" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("sales")}
      >
        Sales Report
      </MenuItem>
      <MenuItem
        component={<Link to="/report/attendance" />}
        style={{
          color: selected === "reportattendance" ? "white" : "black",
          backgroundColor:
            selected === "reportattendance" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("reportattendance")}
      >
        Attendance Report
      </MenuItem>
    </SubMenu>,

    <MenuItem
      style={{
        display: "flex",
        alignItems: "center",
        color: selected === "help" ? "white" : "black",
        backgroundColor: selected === "help" ? "#C0B476" : "transparent",
        marginLeft: "10px",
      }}
      component={<Link to="/help" />}
      onClick={() => handleMenuItemClick("help")}
    >
      <HelpIcon style={{ marginRight: "15px", marginBottom: "-5px" }} />
      Help
    </MenuItem>,
    userPermissions?.export !== 0 && (
      <MenuItem
        style={{
          display: "flex",
          alignItems: "center",
          color: selected === "export" ? "white" : "black",
          backgroundColor: selected === "export" ? "#C0B476" : "transparent",
          marginLeft: "10px",
        }}
        component={<Link to="/export" />}
        onClick={() => handleMenuItemClick("export")}
      >
        <FileUploadIcon style={{ marginRight: "15px", marginBottom: "-5px" }} />
        Export
      </MenuItem>
    ),
    <SubMenu
      label="Appearance"
      icon={<RemoveRedEyeIcon style={{ color: "black" }} />}
      //iconColor="black"
      style={{ display: "flex", alignItems: "center", color: "black" }}
      open={activeSubMenu === "appearance"}
      onClick={() => handleSubMenuClick("appearance")}
    >
      <MenuItem
        component={<Link to="/appearance/blogs" />}
        style={{
          color: selected === "Blogs" ? "white" : "black",
          backgroundColor: selected === "Blogs" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("Blogs")}
      >
        Blogs
      </MenuItem>

      <MenuItem
        component={<Link to="/appearance/plans" />}
        style={{
          color: selected === "Plans" ? "white" : "black",
          backgroundColor: selected === "Plans" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("Plans")}
      >
        Plans
      </MenuItem>
      <MenuItem
        component={<Link to="/appearance/services" />}
        style={{
          color: selected === "Services" ? "white" : "black",
          backgroundColor: selected === "Services" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("Services")}
      >
        Services
      </MenuItem>
      <MenuItem
        component={<Link to="/appearance/features" />}
        style={{
          color: selected === "Features" ? "white" : "black",
          backgroundColor: selected === "Features" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("Features")}
      >
        Features
      </MenuItem>
      <MenuItem
        component={<Link to="/appearance/faq" />}
        style={{
          color: selected === "Faq" ? "white" : "black",
          backgroundColor: selected === "Faq" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("Faq")}
      >
        FAQ
      </MenuItem>
      <MenuItem
        component={<Link to="/appearance/testimonials" />}
        style={{
          color: selected === "Testimonials" ? "white" : "black",
          backgroundColor: selected === "Testimonials" ? "#C0B476" : "transparent",
        }}
        onClick={() => handleMenuItemClick("Testimonials")}
      >
        Testimonials
      </MenuItem>
    </SubMenu>,
    <MenuItem
      style={{
        display: "flex",
        alignItems: "center",
        color: selected === "Settings" ? "white" : "black",
        backgroundColor: selected === "Settings" ? "#C0B476" : "transparent",
        marginLeft: "10px",
      }}
      component={<Link to="/settings" />}
      onClick={() => handleMenuItemClick("Settings")}
    >
      <SettingsIcon style={{ marginRight: "15px", marginBottom: "-5px" }} />
      Settings
    </MenuItem>,
  ];
  const [openIndex, setOpenIndex] = useState(0);
  return (
    <Box
      sx={{
        overflowX: "hidden",
        "& .pro-sidebar-inner": {
          background: `#ffffff !important`,
        },
        "&.pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 5px 5px 5px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#EFF5A3 !important",
        },
        "&.pro-menu-item.active": {
          backgroundColor: "#C0B476 !important", // Background color for active MenuItem
          color: "#F9E747 !important",
        },
      }}
    >
      <Sidebar style={{ width: "15%" }}>
        <Menu>
          <MenuItem
            // icon={<MenuOutlinedIcon />}
            style={{
              margin: "10px 0 10px 0",
              color: "black",

              "&:hover": {
                backgroundColor: "#C0B476",
              },
            }}
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            <Box display="flex" justifyContent="center" alignItems="center">
              <img
                src={LogoExpanded}
                alt="Expanded Logo"
                style={{ width: "140px", height: "auto" }}
              />
              {/* {!showSidebar && <MenuOutlinedIcon />} */}
              {/* <MenuOutlinedIcon /> */}
            </Box>
          </MenuItem>
          {/* paddingLeft={isCollapsed ? undefined : "10%"} */}
          <Box>
            {(isTestUser ? TestUserComponentLists : ComponentLists).map((item, index) => (
              <SidebarIcons
                body={item}
                key={index}
                open={index === openIndex}
                setOpen={() => setOpenIndex(index)}
              />
            ))}
          </Box>
        </Menu>
      </Sidebar>
    </Box>
  );
}

export default MainSidebar;
